import request from './.request'

/**
 * 登录身份验证
 * @param {String}} account 账号名，具体是用户名或手机号 
 * @param {String} password 密码
 * @returns 
 */
export function login(account, password) {
  return request({
    url: 'login',
    method: 'post',
    data: {
      account: account,
      password: password
    }
  })
}

export function loginByToken() {
  return request({
    url: 'login?by=token',
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js